/**
 * ARTPLEX Countdown Timer Component
 * Shows countdown to preorder deadlines for FOMO effect
 */
class ArtplexCountdown extends HTMLElement {
  constructor() {
    super();
    this.intervalId = null;
  }

  connectedCallback() {
    const deadline = this.dataset.deadline;
    if (!deadline) return;

    this.targetDate = new Date(deadline);
    if (isNaN(this.targetDate.getTime())) return;

    this.mode = this.dataset.mode || 'compact'; // 'compact' or 'full'
    this.updateCountdown();
    this.intervalId = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateCountdown() {
    const now = new Date();
    const diff = this.targetDate - now;

    if (diff <= 0) {
      this.innerHTML = this.mode === 'compact'
        ? '<span class="artplex-countdown__expired">Ended</span>'
        : '<div class="artplex-countdown__expired-full">Order period has ended</div>';
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (this.mode === 'compact') {
      this.renderCompact(days, hours, minutes);
    } else {
      this.renderFull(days, hours, minutes, seconds);
    }
  }

  renderCompact(days, hours, minutes) {
    let text = '';
    let urgencyClass = '';

    if (days > 7) {
      text = `${days}d left`;
    } else if (days > 0) {
      text = `${days}d ${hours}h`;
      urgencyClass = 'artplex-countdown--soon';
    } else if (hours > 0) {
      text = `${hours}h ${minutes}m`;
      urgencyClass = 'artplex-countdown--urgent';
    } else {
      text = `${minutes}m left`;
      urgencyClass = 'artplex-countdown--critical';
    }

    this.className = `artplex-countdown artplex-countdown--compact ${urgencyClass}`;
    this.innerHTML = `<span class="artplex-countdown__icon">⏰</span><span class="artplex-countdown__text">${text}</span>`;
  }

  renderFull(days, hours, minutes, seconds) {
    let urgencyClass = '';
    let urgencyMessage = '';

    if (days <= 3 && days > 0) {
      urgencyClass = 'artplex-countdown--soon';
      urgencyMessage = 'Ending Soon!';
    } else if (days === 0 && hours > 0) {
      urgencyClass = 'artplex-countdown--urgent';
      urgencyMessage = 'Ends Today!';
    } else if (days === 0 && hours === 0) {
      urgencyClass = 'artplex-countdown--critical';
      urgencyMessage = 'Order Now!';
    }

    this.className = `artplex-countdown artplex-countdown--full ${urgencyClass}`;
    this.innerHTML = `
      <div class="artplex-countdown__header">
        <span class="artplex-countdown__label">Ends In</span>
        ${urgencyMessage ? `<span class="artplex-countdown__urgency">${urgencyMessage}</span>` : ''}
      </div>
      <div class="artplex-countdown__timer">
        <div class="artplex-countdown__unit">
          <span class="artplex-countdown__value">${String(days).padStart(2, '0')}</span>
          <span class="artplex-countdown__unit-label">Days</span>
        </div>
        <span class="artplex-countdown__separator">:</span>
        <div class="artplex-countdown__unit">
          <span class="artplex-countdown__value">${String(hours).padStart(2, '0')}</span>
          <span class="artplex-countdown__unit-label">Hours</span>
        </div>
        <span class="artplex-countdown__separator">:</span>
        <div class="artplex-countdown__unit">
          <span class="artplex-countdown__value">${String(minutes).padStart(2, '0')}</span>
          <span class="artplex-countdown__unit-label">Min</span>
        </div>
        <span class="artplex-countdown__separator">:</span>
        <div class="artplex-countdown__unit">
          <span class="artplex-countdown__value">${String(seconds).padStart(2, '0')}</span>
          <span class="artplex-countdown__unit-label">Sec</span>
        </div>
      </div>
    `;
  }
}

if (!customElements.get('artplex-countdown')) {
  customElements.define('artplex-countdown', ArtplexCountdown);
}
